import { Retailer } from "@/redux/types";

/**
 * Checks if a retailer supports password reset functionality
 * @param retailer - The retailer object containing retailerId and optional forgotPasswordUrl
 * @returns true if the retailer supports password reset, false otherwise
 */

export const canDoGuestCheckout = (retailerId?: number): boolean => {
  return retailerId === 1;
};

export const canResetPassword = (retailer?: Retailer): boolean => {
  if (!retailer) {
    return false;
  }

  // Check if retailer has a custom forgot password URL
  if ((retailer as any)?.forgotPasswordUrl) {
    return true;
  }

  // Check if retailer is one of the supported ones with hardcoded URLs
  const supportedRetailerIds = [1, 2, 3, 4]; // Amazon, Walmart, Best Buy, Target
  return supportedRetailerIds.includes(retailer.retailerId);
};

/**
 * Opens the appropriate password reset page for a given retailer
 * @param retailer - The retailer object containing retailerId and optional forgotPasswordUrl
 */
export const openResetPassword = (retailer?: Retailer) => {
  if ((retailer as any)?.forgotPasswordUrl) {
    window.open((retailer as any)?.forgotPasswordUrl, "_blank");
    return;
  }

  switch (retailer?.retailerId) {
    case 1:
      window.open(
        "https://www.amazon.com/gp/css/account/forgot-password/email.html",
        "_blank"
      );
      break;
    case 2:
      window.open("https://www.walmart.com/account/forgotpassword", "_blank");
      break;
    case 3:
      window.open("https://www.bestbuy.com/identity/global/signin", "_blank");
      break;
    case 4:
      window.open(
        "https://www.target.com/account/settings/signinsecurity",
        "_blank"
      );
      break;
    default:
      break;
  }
};
